import { ScheduleDetailConstructionZone, ScheduleDetailTask } from '../../types';

import { TransformedGanttSelection } from './transformGanttSelection';

export const getSelectedTasksWithSoil = (
  transformedGanttSelection: TransformedGanttSelection,
  scheduleDetailConstructionZones: ScheduleDetailConstructionZone[]
): ScheduleDetailTask[] => {
  const selectedTasks = transformedGanttSelection.allCrossedTasks;
  return selectedTasks
    .map((task) => {
      const constructionZone = scheduleDetailConstructionZones.find(
        (cz) => cz.id === task.constructionZoneId
      );
      if (!constructionZone) null;
      return constructionZone?.tasks.find((t) => t.id === task.id);
    })
    .filter((task) => task) as ScheduleDetailTask[];
};
